import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const MobiilIdIcon: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="MobiilId" width={width} height={height} alt="iconMobiilId" ignoreRtl {...rest} />
)
